import { Music2, Instagram, Facebook, MapPin } from "lucide-react";

export default function Footer({ settings, locations }) {
  const socials = [
    { name: "TikTok", url: settings.tiktok, icon: Music2 },
    { name: "Instagram", url: settings.instagram, icon: Instagram },
    { name: "Facebook", url: settings.facebook, icon: Facebook },
  ];
  return (
    <footer data-testid="footer" className="bg-primary py-14 text-white">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/assets/logo.png" alt="Logo Electrodomésticos Rivera" className="h-12 w-12 rounded-full border border-white/30 bg-white object-contain" />
              <span className="text-base font-extrabold tracking-tight">Electrodomésticos Rivera</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              Electrodomésticos importados con garantía por escrito y financiamiento en San Pedro Sula, Honduras.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Sucursales</p>
            <p className="mt-3 text-xs text-white/50">Lun–Vie 8:00 AM–5:30 PM · Sáb 8:00 AM–4:30 PM · Dom 9:00 AM–2:00 PM</p>
            <ul className="mt-4 space-y-3">
              {locations.map((loc, i) => (
                <li key={loc.id || i}>
                  <a
                    data-testid={`footer-location-${i}`}
                    href={loc.maps_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-2 text-sm text-white/80 transition-colors duration-300 hover:text-white"
                  >
                    <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
                    <span>
                      {loc.name}
                      <span className="block text-xs text-white/50">{loc.address}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Síguenos</p>
            <div className="mt-4 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.name}
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="flex h-11 w-11 items-center justify-center border border-white/20 transition-colors duration-300 hover:bg-white hover:text-primary"
                >
                  <s.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/15 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Electrodomésticos Rivera · San Pedro Sula, Cortés, Honduras</p>
          <a data-testid="footer-admin-link" href="/admin" className="transition-colors duration-300 hover:text-white">
            Acceso administrativo
          </a>
        </div>
      </div>
    </footer>
  );
}
